export const API = '/api';

export const downloadPdfWithAuth = (url, filename, token) => {
  const separator = url.includes('?') ? '&' : '?';
  const fullUrl = `${url}${separator}token=${encodeURIComponent(token)}`;
  // Use fetch + blob for reliable download without popup blocker
  return fetch(fullUrl)
    .then(response => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.blob();
    })
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename || 'document.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
      return true;
    })
    .catch(err => {
      console.error('Download error:', err);
      // Fallback: open in new tab
      window.open(fullUrl, '_blank');
      return true;
    });
};

export const getPreviewBlobUrl = (url, token) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${encodeURIComponent(token)}&preview=true`;
};

export const PAYS_OPTIONS = [
  { code: 'FR', nom: 'France', indicatif: '+33', flag: 'https://flagcdn.com/w40/fr.png' },
  { code: 'GP', nom: 'Guadeloupe', indicatif: '+590', flag: 'https://flagcdn.com/w40/gp.png' },
  { code: 'MQ', nom: 'Martinique', indicatif: '+596', flag: 'https://flagcdn.com/w40/mq.png' },
  { code: 'GF', nom: 'Guyane francaise', indicatif: '+594', flag: 'https://flagcdn.com/w40/gf.png' },
  { code: 'RE', nom: 'La Reunion', indicatif: '+262', flag: 'https://flagcdn.com/w40/re.png' },
  { code: 'YT', nom: 'Mayotte', indicatif: '+262', flag: 'https://flagcdn.com/w40/yt.png' },
  { code: 'NC', nom: 'Nouvelle-Caledonie', indicatif: '+687', flag: 'https://flagcdn.com/w40/nc.png' },
  { code: 'PF', nom: 'Polynesie francaise', indicatif: '+689', flag: 'https://flagcdn.com/w40/pf.png' },
  { code: 'PM', nom: 'Saint-Pierre-et-Miquelon', indicatif: '+508', flag: 'https://flagcdn.com/w40/pm.png' },
  { code: 'WF', nom: 'Wallis-et-Futuna', indicatif: '+681', flag: 'https://flagcdn.com/w40/wf.png' },
  { code: 'BL', nom: 'Saint-Barthelemy', indicatif: '+590', flag: 'https://flagcdn.com/w40/bl.png' },
  { code: 'MF', nom: 'Saint-Martin', indicatif: '+590', flag: 'https://flagcdn.com/w40/mf.png' },
  { code: 'BE', nom: 'Belgique', indicatif: '+32', flag: 'https://flagcdn.com/w40/be.png' },
  { code: 'CH', nom: 'Suisse', indicatif: '+41', flag: 'https://flagcdn.com/w40/ch.png' },
  { code: 'LU', nom: 'Luxembourg', indicatif: '+352', flag: 'https://flagcdn.com/w40/lu.png' },
  { code: 'MC', nom: 'Monaco', indicatif: '+377', flag: 'https://flagcdn.com/w40/mc.png' },
];

export const TERRITOIRES_OPTIONS = [
  { id: 'metropole', nom: 'France Metropolitaine', zone: 'Europe', emoji: '', description: 'Hexagone + Corse' },
  { id: 'guadeloupe', nom: 'Guadeloupe', zone: 'Antilles', emoji: '', description: 'DROM' },
  { id: 'martinique', nom: 'Martinique', zone: 'Antilles', emoji: '', description: 'DROM' },
  { id: 'saint-barthelemy', nom: 'Saint-Barthelemy', zone: 'Antilles', emoji: '', description: 'COM' },
  { id: 'saint-martin', nom: 'Saint-Martin', zone: 'Antilles', emoji: '', description: 'COM' },
  { id: 'guyane', nom: 'Guyane', zone: 'Amerique du Sud', emoji: '', description: 'DROM' },
  { id: 'saint-pierre', nom: 'Saint-Pierre-et-Miquelon', zone: 'Amerique du Nord', emoji: '', description: 'COM' },
  { id: 'reunion', nom: 'La Reunion', zone: 'Ocean Indien', emoji: '', description: 'DROM' },
  { id: 'mayotte', nom: 'Mayotte', zone: 'Ocean Indien', emoji: '', description: 'DROM' },
  { id: 'nouvelle-caledonie', nom: 'Nouvelle-Caledonie', zone: 'Pacifique', emoji: '', description: 'Collectivite sui generis' },
  { id: 'polynesie', nom: 'Polynesie francaise', zone: 'Pacifique', emoji: '', description: 'COM' },
  { id: 'wallis', nom: 'Wallis-et-Futuna', zone: 'Pacifique', emoji: '', description: 'COM' },
];

export const TERRITOIRES_PAR_ZONE = TERRITOIRES_OPTIONS.reduce((acc, t) => {
  if (!acc[t.zone]) acc[t.zone] = [];
  acc[t.zone].push(t);
  return acc;
}, {});

export const FORMES_JURIDIQUES = [
  'EI', 'EIRL',
  'SCOP SA', 'SCOP SARL', 'SCOP SAS',
  'SCIC SA', 'SCIC SARL', 'SCIC SAS',
  "CAE (Cooperative d'Activite et d'Emploi)",
  'SAS', 'SARL', 'SA', 'EURL', 'SASU',
  'Association', 'Autre'
];
